import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";

interface Props {
  modelValue?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  visibilityToggle?: boolean;
  maxlength?: number;
  status?: "" | "error" | "warning";
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordInput',
  props: {
    modelValue: { default: "" },
    placeholder: { default: "Nhập mật khẩu" },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    visibilityToggle: { type: Boolean, default: true },
    maxlength: { default: undefined },
    status: { default: "" }
  },
  emits: ["update:modelValue", "blur", "pressEnter", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const innerValue = computed({
  get: () => props.modelValue ?? "",
  set: (val: string) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});

const onBlur = (e: FocusEvent) => emit("blur", e);
const onPressEnter = (e: KeyboardEvent) => emit("pressEnter", e);

return (_ctx: any,_cache: any) => {
  const _component_a_input_password = _resolveComponent("a-input-password")!

  return (_openBlock(), _createBlock(_component_a_input_password, {
    value: innerValue.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    size: _ctx.size,
    "visibility-toggle": _ctx.visibilityToggle,
    maxlength: _ctx.maxlength,
    status: _ctx.status,
    class: "ant-password-input",
    onBlur: onBlur,
    onPressEnter: onPressEnter
  }, null, 8, ["value", "placeholder", "disabled", "size", "visibility-toggle", "maxlength", "status"]))
}
}

})